// 📄 types/customDevelopment.ts
// Forma compartida de "Personalizaciones / Desarrollos Z" — se guarda junto
// a requiresOT/otNumber/comments en cada step_* de un canal de integración
// (Commerce vía commerce/integrationService.ts, y SLP/Sourcing/Contracts vía
// solucionIntegrationService.ts), namespaceado por ambiente (DEV/QAS/PRD).
export interface CustomDevelopmentData {
  enabled: boolean;
  name: string;
  location: string;
  otNumber: string;
  codeSnippet: string;
  comments: string;
}

export const emptyCustomDevelopment = (): CustomDevelopmentData => ({
  enabled: false,
  name: '',
  location: '',
  otNumber: '',
  codeSnippet: '',
  comments: ''
});
